// extracted by mini-css-extract-plugin
export default {"prodrow":"productRow_prodrow__MDLJx"};